import React, { useEffect, useContext } from 'react';
import { stopRefreshTimer } from '../../../shared/components/table/editingNow';
import { RefreshBar } from '../../../shared/components/table/RefreshBar';
import DetailsListTable from './DetailsListTable';
import { TablePagination } from '../../../shared/components/table/TablePagination';
import { SkeletonTable } from '../../../shared/components/Skeleton';
import useMyWorkListFunctions from './useMyWorkListFunctions';
import { MyWorkContext } from '../MyWorkContextProvider';
import { getSelectedTabFromStorage } from './myWorkListHelper';
import { Route } from '../../../../route-constants';
import { useLocation } from 'react-router-dom';
import { ResultCount } from '../../../shared/components/ResultCount';
import { appState } from '../../../AppState';

const MyWorkList = () => {
  const currentState = appState(); 
  const { moveToPage, countPerPage, getpaginatedMyWorkList, setMyWorkListInterval } = useMyWorkListFunctions(currentState);
  const { myWorkStates } = useContext(MyWorkContext);
  const location = useLocation();
  const isMyGroupWork = location.pathname.includes(Route.myGroupWork.pagePath);

  useEffect(() => {
    getpaginatedMyWorkList({});
    const timer = setMyWorkListInterval();
    return () => { stopRefreshTimer(timer); };
  }, []);

  return myWorkStates.myWorkList.isFetching ? (
    <SkeletonTable />
  ) : (
    <>
      {/* The loading bar sits flush under the toolbar (100px), over its shadow and the grey divider (102-104px,
          measured), and 3px rather than the lists' 2px: at 2px below the shadow it read as under the line. Outside
          the scroll area, which would clip it, so it never scrolls sideways and spans the width as it is. */}
      {myWorkStates.myWorkList.isRefreshing && <div style={{ position: 'relative', height: 0 }}><RefreshBar board style={{ top: -4, height: 3 }} /></div>}
      <div className={myWorkStates.myWorkList.isRefreshing ? 'list-rows-refreshing' : undefined} style={{ height: 'calc(100vh - 106px - 2.25rem)', overflow: 'auto' }}>
        <DetailsListTable />
      </div>
      <div className='pr-4 h-9 flex items-center'>
        <ResultCount count={myWorkStates.myWorkList.dataCount[getSelectedTabFromStorage(isMyGroupWork) ?? myWorkStates.myWorkList.selectedTabId]} />
        <TablePagination currentPage={myWorkStates.myWorkList.currentPage} totalCount={myWorkStates.myWorkList.dataCount[getSelectedTabFromStorage(isMyGroupWork) ?? myWorkStates.myWorkList.selectedTabId]}
          moveToPage={moveToPage} itemsPerPage={myWorkStates.myWorkList.countPerPage} itemsPerPageChanged={countPerPage} />
      </div>
    </>
  );
};

export default MyWorkList;
